var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyBills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.285,
    height: 65.341,
    viewBox: "0 0 65.285 65.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18913"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6636",
    transform: "translate(14.302 45.994)",
    style: {
      fill: "none"
    },
    d: "M0 0h24.387v5.543H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21931",
    d: "M0 0h11.085v5.543H0z",
    transform: "translate(20.953 20.499)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21930",
    d: "M0 0h24.387v5.543H0z",
    transform: "translate(14.302 32.692)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.807 46.308H17.821a3.164 3.164 0 1 0 0 6.328h18.986a3.164 3.164 0 1 0 0-6.328zM24.15 27.323h6.328a3.164 3.164 0 1 0 0-6.328H24.15a3.164 3.164 0 1 0 0 6.328zm37.971 6.328h-9.493V5.173a3.164 3.164 0 0 0-4.746-2.753l-9.493 5.442L28.9 2.42a3.164 3.164 0 0 0-3.164 0l-9.497 5.442L6.746 2.42A3.164 3.164 0 0 0 2 5.173V55.8a9.493 9.493 0 0 0 9.493 9.493h44.3a9.493 9.493 0 0 0 9.492-9.493V36.815a3.164 3.164 0 0 0-3.164-3.164zM11.493 58.965A3.164 3.164 0 0 1 8.329 55.8V10.647l6.328 3.607a3.417 3.417 0 0 0 3.164 0l9.493-5.443 9.493 5.443a3.417 3.417 0 0 0 3.164 0l6.329-3.607V55.8a9.493 9.493 0 0 0 .57 3.164zM58.956 55.8a3.164 3.164 0 0 1-6.328 0V39.98h6.328zm-22.15-22.15H17.821a3.164 3.164 0 1 0 0 6.328h18.986a3.164 3.164 0 1 0 0-6.328z",
    transform: "translate(-1 -.953)",
    style: {
      stroke: "#f1772d",
      strokeWidth: 2,
      fill: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBills);
export default __webpack_public_path__ + "static/media/my-bills.efe0e0976b575a3622f943b0244fcb52.svg";
export { ForwardRef as ReactComponent };